export default __webpack_public_path__ + "static/media/upload.8ed25108.svg";